import React from "react";
import {
	Grid,
	SectionContainer,
	SectionContent,
	SectionHeader,
	SectionPreTitle,
	SectionTitle,
	SectionSubTitle,
} from "../../styles/global.syles";
import PlansCard from "../PlansCard";
import { PlansContent } from "./Plans.styles";

const plansData = [
	{
		plan: "Plan A",
		price: "25",
		screen: "1",
		isPopular: false,
		features: [
			{ text: "01 Screen", included: true },
			{ text: "Horizontal & Vertical", included: true },
			{ text: "Animations", included: true },
			{ text: "Live Updates", included: true },
			{ text: "Mobile App", included: true },
			{ text: "Video or Image Ads", included: true },
			{ text: "Jackpots & Winners", included: true },
			{ text: "4K Display", included: false },
			{ text: "Custom Developer", included: false },
		],
	},
	{
		plan: "Plan B",
		price: "40",
		screen: "2",
		isPopular: true,
		features: [
			{ text: "02 Screens", included: true },
			{ text: "Horizontal & Vertical", included: true },
			{ text: "Animations", included: true },
			{ text: "Live Updates", included: true },
			{ text: "Mobile App", included: true },
			{ text: "Video & Image Ads", included: true },
			{ text: "Jackpots & Winners", included: true },
			{ text: "4K Display", included: true },
			{ text: "Custom Developer", included: false },
		],
	},
	{
		plan: "Plan C",
		price: "50",
		screen: "3",
		isPopular: false,
		features: [
			{ text: "03 Screens", included: true },
			{ text: "Horizontal & Vertical", included: true },
			{ text: "Animations", included: true },
			{ text: "Live Updates", included: true },
			{ text: "Mobile App", included: true },
			{ text: "Video & Image Ads", included: true },
			{ text: "Jackpots & Winners", included: true },
			{ text: "4K Display", included: true },
			{ text: "Custom Developer", included: false },
		],
	},
	{
		plan: "Plan D",
		price: "60",
		screen: "4",
		isPopular: false,
		features: [
			{ text: "04 Screen", included: true },
			{ text: "Horizontal & Vertical", included: true },
			{ text: "Animations", included: true },
			{ text: "Live Updates", included: true },
			{ text: "Mobile App", included: true },
			{ text: "Video & Image Ads", included: true },
			{ text: "Jackpots & Winners", included: true },
			{ text: "4K Display", included: true },
			{ text: "Custom Developer", included: true },
		],
	},
];

const Plans = () => {
	return (
		<SectionContainer id="pricing" bg="#f8fafd">
			<SectionContent>
				{/* Section header */}
				<SectionHeader>
					<SectionPreTitle>Transparent Pricing</SectionPreTitle>
					<SectionTitle>Simple, High-ROI Subscription Plans</SectionTitle>
					<SectionSubTitle>
						Affordable monthly software licenses designed for any store size. Every plan includes
						automatic jackpot prize updates, mobile app control, and priority remote support.
					</SectionSubTitle>
				</SectionHeader>

				{/* Plans Cards */}
				<PlansContent>
					<Grid gap="24px" columns="repeat(4, 1fr)">
						{plansData.map((item, index) => (
							<PlansCard
								key={index}
								plan={item.plan}
								price={item.price}
								screen={item.screen}
								isPopular={item.isPopular}
								features={item.features}
							/>
						))}
					</Grid>
				</PlansContent>
			</SectionContent>
		</SectionContainer>
	);
};

export default Plans;
